import axios from 'axios';

const adminApi = axios.create({
    baseURL: 'https://api.tournamentgear.com',
});

adminApi.interceptors.request.use((config) => {
    const usssaToken = localStorage.getItem('usssaToken');
    if (usssaToken) {
        config.headers.Authorization = `Bearer ${usssaToken}`;
    }
    config.headers['x-api-key'] = '500aca9b-664a-41b6-bca7-777e51a9402f';
    return config;
});

// Roles Endpoints
export const getRoles = (params) => adminApi.get('/admin/roles/list', { params });
export const assignRole = (data) => adminApi.post('/admin/roles/add', data);
export const updateRole = (data) => adminApi.put('/admin/roles/update', data);
export const removeRole = (userId) => adminApi.delete(`/admin/roles/${userId}`);

// Phone Whitelist Endpoints
export const getPhoneWhitelist = (directorId) => adminApi.get('/admin/directors/phoneWhitelist', { params: { director_id: directorId } });
export const addPhoneToWhitelist = (data) => adminApi.post('/admin/directors/phoneWhitelist', data);
export const removePhoneFromWhitelist = (data) => adminApi.delete('/admin/directors/phoneWhitelist', { data });

export default adminApi;
